import { useEffect, useState } from 'react';
import { format, sub } from 'date-fns';
import { Search } from 'react-feather';
import { useRemote } from '../../../Utils/Utils';
import Table from '../../../components/Table/Table';
import IconCounter from '../../../components/IconCounter';
import AnalyticsHeader from './AnalyticsHeader';

const TopSearches = ({ dateRanges, label, mb, timeFrame, centralizedDateRange }) => {

	const remote = useRemote();
	const [timePeriod, setTimePeriod] = useState(centralizedDateRange ? timeFrame : dateRanges[0]);
	const [stats, setStats] = useState([]);
	const end = format(new Date(), 'yyyy-MM-dd');

	useEffect(() => {
		let time = { months: 6 }
		if (timePeriod) time = centralizedDateRange ? timeFrame : timePeriod

		let date = typeof time === "string" ? time : format(sub(new Date(), time), "yyyy-MM-dd")

		remote.get(`/analytics/aggregates/searches?from=${date}&to=${end}`).then(setStats);
	}, [timePeriod, timeFrame]);


	const data = stats.slice(0, 5);

	const colWidths = ["92%", "60px"];

	const dataMap = () => data && data.map((search, idx) => {
		return (
			<tr key={idx} /*className="cursor-pointer"*/>
				<td style={{ fontSize: '0.85rem' }}>
					{search.searchTerm}
				</td>
				<td className="table-action-icons transition-fade-in-slow" style={{ textAlign: "left" }}>
					<IconCounter icon={<Search />} tooltip={"Searched"} dataAvailable count={search.count} pointer="default" small />
				</td>
			</tr>
		);
	});

	return (
		<>
			<AnalyticsHeader dateRanges={centralizedDateRange ? null : dateRanges} timeFrame={centralizedDateRange ? timeFrame : timePeriod} setTimeFrame={setTimePeriod} mb={mb}>{label ? label : "Search Terms"}</AnalyticsHeader>
			<Table suggestionMessage rowSize="s" colWidths={colWidths} dataMap={dataMap()} />
		</>
	);
}

export default TopSearches;